import { styled } from '@mui/material/styles';
import { TableCell } from 'shared/mui/Table';

export const StyledTableCellHeader = styled(TableCell)({
  paddingLeft: '24px',
  paddingRight: '24px',
});
